export default "__VITE_ASSET__Cd8hUKMe__"